import { render, staticRenderFns } from "./lessonTeacherView.vue?vue&type=template&id=35c11afa&"
import script from "./lessonTeacherView.vue?vue&type=script&lang=js&"
export * from "./lessonTeacherView.vue?vue&type=script&lang=js&"
import style0 from "./lessonTeacherView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports